import React, { useState } from 'react';
import { LayoutGrid } from 'lucide-react';
import { moduleLabel } from '@/lib/usageTracker';
import { DarkCard, RankedList, CardToggle } from './RankedCard';
import { fmtMinutes } from './usageApi';

export const TopModulesCard = ({ modules }) => {
  const [by, setBy] = useState('views');
  const total = modules.reduce((s, m) => s + m[by], 0) || 1;
  const items = [...modules]
    .sort((a, b) => b[by] - a[by])
    .filter((m) => m[by] > 0)
    .map((m) => ({
      key: m.module,
      label: moduleLabel(m.module),
      icon: <LayoutGrid className="h-3.5 w-3.5 text-neutral-500" />,
      value: by === 'views' ? `${Math.round((m.views / total) * 100)}%` : fmtMinutes(m.minutes),
      pct: (m[by] / total) * 100,
    }));
  return (
    <DarkCard
      title="Top modules"
      testId="usage-top-modules"
      right={<CardToggle testId="usage-top-modules-by" value={by} onChange={setBy} options={[['views', 'By page views'], ['minutes', 'By time']]} />}
    >
      <RankedList items={items} testId="usage-top-modules-list" />
    </DarkCard>
  );
};
